import React, {FC} from "react";
import Divider from "../divider";
import Spacer from "../spacer";
import VidaSection from "../../../../components/@vida/vida-section";
import Note from "../note";

const PlatformIdentification: FC = () => {
  return <div>
    <VidaSection title="" id="platform-identification">
      <Divider/>
      <h1>Platform Identification</h1>

      {/* SPA and CMA platform Identification */}
      <Spacer/>
      <VidaSection title="SPA and CMA platform Identification"
                   id="spa-and-cma-platform-identification">
        <p><strong>SPA and CMA Platform Identification</strong></p>
        <Note body={<p>These Platforms are mentioned in VIDA as <strong>VDS protocol</strong> - P3 and older cars with
          connectivity are mentioned in VIDA as <strong>GGD and D2 protocol</strong>.</p>}/>
        <p><strong>SPA Platform</strong></p>
        <p><strong>P5</strong></p>
        <table>
          <tr>
            <th>Model</th>
            <th>Type</th>
            <th>Model Years</th>
          </tr>
          <tr>
            <td>XC90</td>
            <td>256</td>
            <td>2016-</td>
          </tr>
          <tr>
            <td>S90</td>
            <td>234</td>
            <td>2017</td>
          </tr>
          <tr>
            <td>S90</td>
            <td>238</td>
            <td>2018-</td>
          </tr>
          <tr>
            <td>V90</td>
            <td>235</td>
            <td>2017-</td>
          </tr>
          <tr>
            <td>V90CC</td>
            <td>236</td>
            <td>2017-</td>
          </tr>
          <tr>
            <td>XC60</td>
            <td>246</td>
            <td>2018-</td>
          </tr>
          <tr>
            <td>S60</td>
            <td>224</td>
            <td>2019-</td>
          </tr>
          <tr>
            <td>V60</td>
            <td>225</td>
            <td>2019-</td>
          </tr>
          <tr>
            <td>V60CC</td>
            <td>227</td>
            <td>2019-</td>
          </tr>
        </table>
        <p><strong>P6</strong></p>
        <table>
          <tr>
            <th>Model</th>
            <th>Type</th>
            <th>Model Years</th>
          </tr>
          <tr>
            <td>XC40</td>
            <td>536</td>
            <td>2019-</td>
          </tr>
          <tr>
            <td>C40</td>
            <td>539</td>
            <td>2022-</td>
          </tr>
        </table>
        <p><strong>P3</strong></p>
        <table>
          <tr>
            <th>Model</th>
            <th>Type</th>
            <th>Model Years</th>
          </tr>
          <tr>
            <td>S80</td>
            <td>124</td>
            <td>2007 - 2016</td>
          </tr>
          <tr>
            <td>V70</td>
            <td>135</td>
            <td>2008 - 2010</td>
          </tr>
          <tr>
            <td>XC70</td>
            <td>136</td>
            <td>2008 - 2016</td>
          </tr>
          <tr>
            <td>XC60</td>
            <td>156</td>
            <td>2010 - 2018</td>
          </tr>
          <tr>
            <td>S60</td>
            <td>134</td>
            <td>2011 - 2018</td>
          </tr>
          <tr>
            <td>V60</td>
            <td>155</td>
            <td>2015 - 2018</td>
          </tr>
          <tr>
            <td>S60CC</td>
            <td>137</td>
            <td>2016 - 2018</td>
          </tr>
          <tr>
            <td>V60CC</td>
            <td>157</td>
            <td>2015.5 - 2018</td>
          </tr>
          <tr>
            <td>S60I</td>
            <td>138</td>
            <td>2016 - 2018</td>
          </tr>
        </table>
      </VidaSection>
    </VidaSection>
  </div>
}

export default PlatformIdentification;
